// supportportal_web login
export const API_SUPPORT_PORTAL_LOGIN = '/cmsadmin/api/auth/authenticate';

// Invalidate token
export const API_INVALIDATE_TOKEN = '/cmsadmin/api/auth/invalidate';

//getAllusers
export const API_GET_ALL_USERS = '/cmsadmin/api/users';

//createUser
export const API_CREATE_USER = '/cmsadmin/api/auth/register';
export const API_GET_ROLE_ID = '/cmsadmin/api/table?name=account_role';

//delete user
export const API_DELETE_USER = '/cmsadmin/api/users';

//Edit user
export const API_UPDATE_USER = '/cmsadmin/api/users';

//get role
export const API_GET_ACCOUNT_ROLES = '/cmsadmin/api/accountRoles';

//creat role 
export const API_CREATE_ROLE = '/cmsadmin/api/accountRoles';
export const API_GET_ROLE_GRADE = '/cmsadmin/api/table?name=account_grade';

//delete role 
export const API_DELETE_ROLE = '/cmsadmin/api/accountRoles?roleId=';

//update role
export const API_UPDATE_ROLE = '/cmsadmin/api/accountRoles/update';

//digital price - get list
export const API_DIGITAL_PRICE_FETCH_LIST = '/cmsadmin/api/priceTagSettings/getListAllDistData';

// get list all select shop distribution data
export const API_DIGITAL_PRICE_FETCH_LIST_SELECT_SHOP = '/cmsadmin/api/priceTagSettings/getListAllSelectShopDistData';

//upload excel
export const API_UPLOAD_EXCEL = '/cmsadmin/api/priceTagSettings/import';

// update digital price tag data
export const API_UPDATE_DIGITAL_PRICE_TAG_DATA = '/cmsadmin/api/priceTagSettings/updateDigitalPriceTagData';

// digital price-get list all distribution data in Excel format
export const API_DIGITAL_PRICE_FETCH_LIST_EXCEL = '/cmsadmin/api/priceTagSettings/getListAllDistExcel';

// get all shop list
export const API_GET_ALL_SHOP_LIST = '/cmsadmin/api/priceTagSettings/getAllShopList';